import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
    setScrollingToSearchedLayer
} from '../../../../redux/panel/search_panel/Actions';

import LayerRow from './LayerRow';


function AdditionalLayerDropdownRow ({ layer, activeLayer, classes }) {
    const rootRef = useRef();
    const searchPanel = useSelector(state => state.search_panel);
    const dispatch = useDispatch();

    useEffect(() => {
        setTimeout(() => {
            if (searchPanel.selectedLayer.systemName === layer.system_name) {
                if (searchPanel.scrollingToSelectedLayer) {
                    rootRef.current.scrollIntoView({
                        block: 'center'
                    });
                    rootRef.current.classList.remove(classes.highlighted);
                    rootRef.current.classList.add(classes.highlighted);
                    dispatch(setScrollingToSearchedLayer(false));
                }
            }
        }, 500);
    }, [searchPanel.selectedLayer.systemName, searchPanel.scrollingToSelectedLayer]);

    return (<div id={layer.system_name} ref={rootRef}>
        <LayerRow
            layer={layer}
            activeLayer={activeLayer}
        />
    </div>
    );
}

export default AdditionalLayerDropdownRow;